import React from 'react';
import { Text } from '@carnica/ui-kit';
import { getBalanceDateText } from '@beef/elk-common/utils';
export var BalanceByDate = function BalanceByDate(_ref) {
  var _ref$lastDate = _ref.lastDate,
    lastDate = _ref$lastDate === void 0 ? '' : _ref$lastDate;
  return lastDate ? /*#__PURE__*/React.createElement("div", {
    className: "mar-t-4xs",
    "data-t-id": "components-BalanceByDate"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    variant: "caption-medium"
  }, getBalanceDateText(lastDate, ','))) : null;
};